import { render } from "./HomeApprovementsPage.vue?vue&type=template&id=04555576&ts=true"
import script from "./HomeApprovementsPage.vue?vue&type=script&lang=ts"
export * from "./HomeApprovementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__